import * as PIXI from "pixi.js";
import {config} from "../config";
import data from "./configs/data";
import {Dice} from "./Dice";

export class BetPanelTextField extends PIXI.Container {

    private readonly HEADER_TEXT_POSITION: any = new PIXI.Point(0, -53);

    private readonly DEFAULT_ANCHOR_POINT: any = new PIXI.Point(0.5, 0.5);
    private readonly CURRENCY_TYPE_POSITION = new PIXI.Point(113, -3);
    private readonly VALUE_POSITION = new PIXI.Point(-113, -3);

    private readonly HEADER_TEXT_STYLE = {
        fontSize: 26,
        fontFamily: "RobotoRegular",
        fill: "#b2b2b2",
    };

    private readonly VALUE_TEXT_STYLE = {
        fontSize: 32,
        fontFamily: "RobotoRegular",
        fill: "#fff",
    };

    private readonly CURRENCY_TEXT_STYLE = {
        fontSize: 20,
        fontFamily: "RobotoRegular",
        fill: "#fff",
    };

    private valueText: PIXI.Text;
    private currencyText: PIXI.Text;

    constructor(headerText: string) {
        super();
        this.createAndAddBackground();
        this.createHeaderText(headerText);
        this.createAndAddValueText();
        this.createAndAddCurrencyTypeText();
    }

    public setValue(value: string, currencyType: string): void {
        this.valueText.text = value;
        this.currencyText.text = config.displayCurrency;
    }

    private createAndAddValueText(): void {
        this.valueText = new PIXI.Text("", this.VALUE_TEXT_STYLE);
        this.valueText.position = this.VALUE_POSITION;
        this.valueText.anchor = this.DEFAULT_ANCHOR_POINT;
        this.valueText.anchor.x = 0;
        this.addChild(this.valueText);
    }

    private createAndAddCurrencyTypeText(): void {
        this.currencyText = new PIXI.Text("", this.CURRENCY_TEXT_STYLE);
        this.currencyText.position = this.CURRENCY_TYPE_POSITION;
        this.currencyText.anchor = this.DEFAULT_ANCHOR_POINT;
        this.currencyText.anchor.x = 1;
        (window as any).currencyText = this.currencyText;
        this.addChild(this.currencyText);
    }

    private createHeaderText(text: string): void {
        const headerText = new PIXI.Text(text, this.HEADER_TEXT_STYLE);
        headerText.position = this.HEADER_TEXT_POSITION;
        headerText.anchor = this.DEFAULT_ANCHOR_POINT;
        this.addChild(headerText);
    }

    private createAndAddBackground(): void {
        const background = PIXI.Sprite.fromImage(data.images.betValueBackground);
        background.anchor = this.DEFAULT_ANCHOR_POINT;
        background.scale = Dice.ELEMENTS_SCALE;
        this.addChild(background);
    }
}



// WEBPACK FOOTER //
// ./src/app/BetPanelTextField.ts